export default __webpack_public_path__ + "static/fall7-e273cdd5eb844bf57dd4cf57686093d4.webp";